const getters = {
  sidebar: state => state.app.sidebar,
  token: state => {},
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  tenant: state => state.user.tenant,
  departmentId: state => state.user.departmentId,
  tenantId: state => state.user.tenantId,
  mobilePhone: state => state.user.mobilePhone,
  organizationInfo: state => state.user.organizationInfo,
  userInfo: state => state.user.userInfo,
  userId: state => state.user.userId,
  staffId: state => state.user.userInfo.staffId,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routes: state => state.permission.routes,
  add_routes: state => state.permission.addRoutes,
  sealConfig: state => state.user.sealConfig,
  subsidiaryLists: state => state.user.subsidiaryLists,
  companyPermissionCommunityLists: state => state.user.companyPermissionCommunityLists,
  currentOrganizationId: state => state.user.currentOrganizationId,
  firstCommunityId: state => state.user.firstCommunityId,
  companyModifyCommunityLists: state => state.user.companyModifyCommunityLists,
  userPermissionLists: state => state.permission.userPermissionLists,
  userPermissionItemLists: state => state.permission.userPermissionItemLists,
  routesCut: state => state.permission.routesCut,
  PermissionRouter: state => state.permission.PermissionRouter,
  personnelOrganization: state => state.user.personnelOrganization,
}
export default getters
